import React, {useEffect, useState} from "react";
import { Helmet } from 'react-helmet';
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import './payment-types_style.css';
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import DeletedPaymentTypes from "./DeletedPaymentTypes";

function PaymentTypes ({ handleMenuClick }){

    const [paymenttype, setPaymenttype] = useState([]);
    const [updateTrigger, setUpdateTrigger] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [showDeleted, setShowDeleted] = useState(false);  // Nuevo estado para controlar la vista

    const filteredData = searchValue
    ? paymenttype.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : paymenttype;

    const indexOfLastData = currentPage * dataPerPage;
    const indexOfFirstData = indexOfLastData - dataPerPage;

    const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
    const pageNumbers = [];
    const maxPageNumbersToShow = 20;

    let startPage, endPage;
    if (totalPageCount <= maxPageNumbersToShow) {
        startPage = 1;
        endPage = totalPageCount;
    } else {
        startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage < maxPageNumbersToShow) {
        startPage = endPage - maxPageNumbersToShow + 1;
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    const showEntries = (e) => {
        setDataPerPage(e.target.value);
    };

    const handleSearch = () => {
        const input = document.getElementById("searchInput");
        setSearchValue(input.value.trim());
    };

    const getPaymentType = async () => {
        try{
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setPaymenttype(res.data.data);
                setLoading(false);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos", "error");
                setLoading(false);
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos", "error");
            setLoading(false);
        }
    };

    //Eliminar tipo de pago
    const deletePaymentType = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¡No podrás revertir esto!",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, eliminarlo",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/destroy/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });
                console.log('Response:', response);

                Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
                setUpdateTrigger(!updateTrigger);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    //Editar tipo de pago
    const updatePaymentType = async (id) => {
        try {
            //Obtener los datos de la condición de pago
            const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/find/${id}`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            const PaymentTypeData = response.data.data;

            const result = await Swal.fire({
                title: "Editar tipo de pago",
                html:
                `<div class="form-grid">` +
                `<input type="text" id="name" class="swal2-input" placeholder="Nombre" value="${PaymentTypeData[0].name}">` +
                `<input type="text" id="code" class="swal2-input" placeholder="Código" value="${PaymentTypeData[0].code}">` +
                `</div>`,
                showDenyButton: true,
                confirmButtonText: "Actualizar",
                denyButtonText: "Cancelar",
                padding: "1px",
                color: "#000",
                backdrop: `
                    rgba(0,0,0,0.8)
                `,
                customClass: {
                    confirmButton: "btn-amc-blue",
                    denyButton: "btn-cancel",
                    title: "alert-title",
                    popup: "alert-bg",
                },
                preConfirm: async () => {
                    const name = document.getElementById("name").value;
                    const code = document.getElementById("code").value;
            
                    if (!name) {
                        Swal.showValidationMessage("Nombre obligatorio");
                        return false;
                    }
            
                    return {
                        name,
                        code
                    };
                },
                allowOutsideClick: () => !Swal.isLoading()
            });

            if (result.isConfirmed) {
                const updateUserData = result.value;
                // Realizar la solicitud PUT al servidor para actualizar la tarima
                const updateResponse = await axios.post(
                    `${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/update/${id}`, updateUserData,
                    {
                        headers: {
                          Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                        },
                      }
                );
                Swal.fire(
                    "¡Actualizado!",
                    "El tipo de pago ha sido actualizado exitosamente.",
                    "success"
                );
                setUpdateTrigger(!updateTrigger);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    "Cancelado",
                    "No se ha realizado ninguna actualización.",
                    "error"
                );
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    //Crear nuevo tipo de pago
    const createPaymentType = async () => {
        try {
            const result = await Swal.fire({
                title: "Crear tipo de pago",
                html:
                '<div class="form-grid">' +
                '<input type="text" id="name" class="swal2-input" placeholder="Nombre">' +
                '<input type="text" id="code" class="swal2-input" placeholder="Código">' +
                "</div>",
                showDenyButton: true,
                confirmButtonText: "Crear",
                denyButtonText: "Cancelar",
                padding: "1px",
                color: "#000",
                backdrop: `
                    rgba(0,0,0,0.8)
                `,
                customClass: {
                    confirmButton: "btn-amc-blue",
                    denyButton: "btn-cancel",
                    title: "alert-title",
                    popup: "alert-bg",
                },
                preConfirm: async () => {
                    const name = document.getElementById("name").value;
                    const code = document.getElementById("code").value;
            
                    if (!name) {
                        Swal.showValidationMessage("Nombre obligatorio");
                        return false;
                    }
            
                    return {
                        name,
                        code
                    };
                },
                allowOutsideClick: () => !Swal.isLoading()
            });
        
            if (result.isConfirmed) {
                const userData = result.value;
        
                const response = await axios.post(
                    `${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_types/store`, userData,
                    {
                        headers: {
                            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                        },
                    }
                );
        
                Swal.fire(
                "¡Creado!",
                "El tipo de pago ha sido creado exitosamente.",
                "success"
                );
                setUpdateTrigger(!updateTrigger);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado", "Acción cancelada.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getPaymentType();
    }, [updateTrigger]);

    return(
        <>
            <Helmet>
                <title>Horus | Tipos de pago</title>
            </Helmet>
            <ScrollToTop />
            <div className='table-responsive'>
                <div className='dataTables_wrapper dt-bootstrap4 no-footer' id='datatables_wrapper'>
                    <div className="text-right mb-2 ">
                        <button className="btnn" onClick={() => setShowDeleted(!showDeleted)}>
                            {showDeleted ? "Ver Activos" : "Ver Eliminados"}
                        </button>
                        
                    </div>
                    {showDeleted ? (
                        <DeletedPaymentTypes setUpdateTrigger={setUpdateTrigger} updateTrigger={updateTrigger} />
                    ) : (
                        <>
                            <div className="text-right mb-4 ">
                                <button className="btnn" onClick={createPaymentType}>
                                Añadir Tipos de Pago
                                </button>
                            </div>
                            <div className="row justify-content-between mb-2">
                                <div className="col-sm-12 col-md-4">
                                    <div className="dataTables_length mb-2" id="dataTables_length">
                                        <label className="d-flex justify-content-start">
                                        <span className="mr-2 p-2">Mostrar</span>
                                        <select
                                            name="datatables_length"
                                            aria-controls="datatables_length"
                                            className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                                            onChange={showEntries}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span className="ml-2 p-2">registros</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <div className="datatables_filter" id="datatables_filter">
                                        <label className="d-flex justify-content-end">
                                        <input
                                            type="search"
                                            id="searchInput"
                                            className="form-control form-control-sm"
                                            placeholder="Buscar..."
                                            aria-controls="datatables"
                                        />
                                        <button className="btnn" onClick={handleSearch}>
                                            Buscar
                                        </button>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <table
                                        className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                                        role="grid"
                                        aria-describedby="datatables_info"
                                    >
                                        <thead>
                                            <tr>
                                                <th>
                                                    Nombre
                                                </th>
                                                <th>
                                                    Acciones
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentData.map((paytype) => (
                                                <tr key={paytype.id} data-master-id={paytype.id}>
                                                    <td>{paytype.name}</td>
                                                    <td>
                                                        <FaEdit className='editButton' onClick={() => { updatePaymentType(paytype.id) }} />
                                                        <FaTimes className='deleteButton' onClick={() => { deletePaymentType(paytype.id) }} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row">
                                <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item">
                                    <button
                                        className="page-link"
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Anterior
                                    </button>
                                    </li>
                                    {pageNumbers.map((pageNumber) => (
                                    <li className="page-item" key={pageNumber}>
                                        <button
                                        className="page-link"
                                        onClick={() => paginate(pageNumber)}
                                        >
                                        {pageNumber}
                                        </button>
                                    </li>
                                    ))}
                                    <li className="page-item">
                                    <button
                                        className="page-link"
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentPage === pageNumbers.length}
                                    >
                                        Siguiente
                                    </button>
                                    </li>
                                </ul>
                                </nav>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    )

}

export default PaymentTypes